<template>
    <va-create-layout>
        <RentalTransactionEventCharge-form
            :title="title"
            :item="item"
        ></RentalTransactionEventCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
